import React from 'react';
import IconButton from './IconButton';

export default function (props) {
  return (
    <IconButton icon="times" onClick={props.onClick} />
  );
}
